/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-unresolved */
import {
    useLazyQuery, useMutation, useQuery, useReactiveVar,
} from '@apollo/client';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { CREATE_FR2052A_USER_COMMENT, DELETE_FR2052A_USER_COMMENT, UPDATE_FR2052A_USER_COMMENT } from 'Apollo/Mutations/Rules/FR2052A';
import { GET_USER_INFO } from 'Apollo/Queries';
import { GET_USER_COMMENTS_FOR_FR2052A } from 'Apollo/Queries/Rules/FR2052aResults';
import { tenantIdVar } from 'Apollo/config';
import FR2052AComment from '../components/FR2052AComment';

const FR2052AComments = ({ refetch }) => {
    const location = useLocation();
    const [batchId, setBatchId] = useState(location.state.batchId);
    const [ruleId, setRuleId] = useState(location.state.ruleId);
    const [fr2052aComment, setFR2052AComment] = useState('');
    const [fr2052aShow, setFR2052AShow] = useState(false);
    const [fr2052aTarget, setTarget] = useState(null);
    const [fr2052aEdit, setEdit] = useState(false);
    const [fr2052aSelectedComment, setFR2052ASelectedComment] = useState('');
    const [fr2052aSelectedCommentID, setSelectedCommentID] = useState('');
    const [fr2052aSelectedIndex, setSelectedIndex] = useState(null);
    const tenantId = useReactiveVar(tenantIdVar);

    /* Apollo query to fetch user information  */
    const getFR2052AUser = useQuery(GET_USER_INFO);

    /* Apollo lazy query to fetch all the comments  */
    const [getComments, { loading, data: { getUserCommentsForFR2052A = {} } = {} }] = useLazyQuery(GET_USER_COMMENTS_FOR_FR2052A, {
        variables: {
            input: {
                batchId: parseInt(batchId, 10),
                ruleId: parseInt(ruleId, 10),
                tenantId: parseInt(tenantId, 10),
            },
        },
        fetchPolicy: 'no-cache',
    });

    /* Apollo mutation to add new comment  */
    const [addResultComment, { loading: commentLoading }] = useMutation(CREATE_FR2052A_USER_COMMENT, {
        variables: {
            input: {
                batchId: parseInt(batchId, 10),
                ruleId: parseInt(ruleId, 10),
                tenantId: parseInt(tenantId, 10),
                commentText: fr2052aComment,
            },
        },
    });

    /* Apollo mutation to delete a comment  */
    const [deleteComment] = useMutation(DELETE_FR2052A_USER_COMMENT);

    /* Apollo mutation to update comment  */
    const [updateComment] = useMutation(UPDATE_FR2052A_USER_COMMENT);

    /* Comment option handler */
    const handleFR2052AClick = (index, text, commentId, event) => {
        setFR2052AShow(!fr2052aShow);
        setSelectedIndex(index);
        setFR2052ASelectedComment(text);
        setSelectedCommentID(commentId);
        setTarget(event.target);
    };

    /* Calls  addResultComment(), getComments() and refetch that failed tests result */
    const addFR2052AComment = async () => {
        await addResultComment();
        getComments();
        refetch();
        setFR2052AComment('');
    };

    /* Toggled edit value */
    const onFR2052AEditClick = () => {
        setEdit(!fr2052aEdit);
    };

    /* Cancal button handler */
    const onFR2052ACancelClick = () => {
        setEdit(!fr2052aEdit);
        setSelectedIndex(null);
        setFR2052ASelectedComment('');
        setFR2052AShow(!fr2052aShow);
    };

    /* Calls updateComment and refetch the failed tests resut */
    const onFR2052AClickSave = async () => {
        await updateComment({
            variables: {
                input: {
                    commentText: fr2052aSelectedComment,
                    commentId: fr2052aSelectedCommentID,
                    tenantId: parseInt(tenantId, 10),
                    batchId,
                    ruleId,
                },
            },
        });
        getComments();
        setEdit(!fr2052aEdit);
        setSelectedIndex(null);
        setFR2052ASelectedComment('');
        setFR2052AShow(!fr2052aShow);
        refetch();
    };

    /* Calls deleteComment and refetch the failed tests resut */
    const onFR2052AClickDelete = async () => {
        await deleteComment({
            variables: {
                input: {
                    commentId: fr2052aSelectedCommentID,
                    tenantId: parseInt(tenantId, 10),
                    batchId,
                    ruleId,
                },
            },
        });
        getComments();
        setSelectedIndex(null);
        setFR2052ASelectedComment('');
        setFR2052AShow(!fr2052aShow);
        refetch();
    };

    /* Side effect to fetch comments initially */
    useEffect(() => {
        getComments();
    }, []);

    /* Side effect when location state updates */
    useEffect(() => {
        setBatchId(location.state.batchId);
        setRuleId(location.state.ruleId);
    }, [location]);

    return (
        <FR2052AComment
            getFR2052AUser={getFR2052AUser}
            fr2052aComment={fr2052aComment}
            setFR2052AComment={setFR2052AComment}
            commentLoading={commentLoading}
            addFR2052AComment={addFR2052AComment}
            loading={loading}
            getUserCommentsForFR2052A={getUserCommentsForFR2052A}
            handleFR2052AClick={handleFR2052AClick}
            onFR2052AEditClick={onFR2052AEditClick}
            onFR2052AClickDelete={onFR2052AClickDelete}
            onFR2052ACancelClick={onFR2052ACancelClick}
            onFR2052AClickSave={onFR2052AClickSave}
            fr2052aShow={fr2052aShow}
            fr2052aTarget={fr2052aTarget}
            fr2052aEdit={fr2052aEdit}
            fr2052aSelectedComment={fr2052aSelectedComment}
            fr2052aSelectedCommentID={fr2052aSelectedCommentID}
            setFR2052ASelectedComment={setFR2052ASelectedComment}
            fr2052aSelectedIndex={fr2052aSelectedIndex}
        />
    );
};

export default FR2052AComments;
